module.exports = __webpack_public_path__ + "img/shaq.9229933e.png";